import { Navigate, useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Spinner } from '@shared/ui';
import { ROUTES } from '@shared/config/routes';
import { useLocalizedText } from '@shared/lib/use-localized';
import { useProductQuery } from '@entities/product';
import { ProductForm } from '@features/product-form';
import { ProductStatusChip } from '@features/product-list';

export function ProductEditPage() {
  const { t } = useTranslation();
  const { id } = useParams<{ id: string }>();
  const { data: product, isLoading, isError } = useProductQuery(id);
  const localizeText = useLocalizedText();

  if (isLoading) {
    return (
      <div className="flex h-full items-center justify-center">
        <Spinner />
      </div>
    );
  }
  if (isError || !product) return <Navigate to={ROUTES.products} replace />;

  return (
    <div className="flex flex-col gap-6">
      <header className="flex items-start justify-between gap-4">
        <div>
          <h1 className="text-2xl font-semibold">{localizeText(product.name)}</h1>
          <p className="text-sm opacity-70">{t('products.editTitle')}</p>
        </div>
        <ProductStatusChip status={product.status} title={product.rejectionReason ?? undefined} />
      </header>
      <ProductForm product={product} />
    </div>
  );
}
